import { useRef } from "react";
import ModalPop from "./ModalPop";

const Event = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div id="event" className=" relative w-full h-full event-bg">
      <div className="relative w-full h-full px-[calc((100%-var(--container))/5)] 3xl:px-[calc((100%-var(--container))/2)] mx-auto">
        <img
          onClick={openfunc}
          src="/images/eventPc.png"
          alt="싹치워드림 유품정리·특수청소 진행 이벤트 안내"
          width={2558}
          height={1273}
          className="hidden xl:block !relative w-full h-auto"
        />
        <img
          onClick={openfunc}
          src="/images/eventMo.png"
          alt="싹치워드림 유품정리·특수청소 진행 이벤트 안내"
          width={451}
          height={739}
          className="block xl:hidden !relative w-full h-auto"
        />
      </div>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
    </div>
  );
};

export default Event;
